import React from "react";
import { Dropdown } from "../Dropdown";
import { InlinePickDropdown } from "../InlinePickDropdown";
import { Hint } from "../DistributionStepSection/DistributionStepSection.styles";
import { Field, FieldLabel } from "../shared/scheduleField.styles";
import { QUARTER_MONTH_OPTIONS, parseQuarterMonth } from "./DistributionQuarterlyFields.options";
import type { DistributionQuarterlyFieldsProps } from "./DistributionQuarterlyFields.types";

/** Quarterly "On": the month of the quarter. Stateless; the menu comes from the organism. */
export const DistributionQuarterlyFields: React.FC<DistributionQuarterlyFieldsProps> = ({
  month,
  monthMenu,
  onChangeMonth,
  hint,
  appearance = "field",
  className,
}) => {
  const pick = (value: string) => {
    onChangeMonth(parseQuarterMonth(value));
    monthMenu.onClose();
  };
  const dropdown =
    appearance === "inline" ? (
      <InlinePickDropdown
        value={String(month)}
        options={QUARTER_MONTH_OPTIONS}
        open={monthMenu.open}
        triggerRef={monthMenu.triggerRef}
        menuRef={monthMenu.menuRef}
        menuRect={monthMenu.menuRect}
        ariaLabel="Month of the quarter"
        onToggle={monthMenu.onToggle}
        onSelect={pick}
      />
    ) : (
      <Dropdown
        value={String(month)}
        options={QUARTER_MONTH_OPTIONS}
        open={monthMenu.open}
        triggerRef={monthMenu.triggerRef}
        menuRef={monthMenu.menuRef}
        menuRect={monthMenu.menuRect}
        size="md"
        compact
        fullWidth
        ariaLabel="Month of the quarter"
        onToggle={monthMenu.onToggle}
        onSelect={pick}
      />
    );
  if (appearance === "inline") return dropdown;
  return (
    <Field className={className}>
      <FieldLabel>Month of the quarter</FieldLabel>
      {dropdown}
      {hint ? <Hint>{hint}</Hint> : null}
    </Field>
  );
};

export default DistributionQuarterlyFields;
